import { EmailContact } from './email-contact';

export class Email {
   public from: string;
   public to: EmailContact[];
   public cc: EmailContact[];
   public bcc: EmailContact[];
   public subject: string;
   public body: string;

   constructor(from?: string, to?: EmailContact[], cc?: EmailContact[], bcc?: EmailContact[], subject?: string, body?: string) {
      this.from = from;
      this.to = to;
      this.cc = cc;
      this.bcc = bcc;
      this.subject = subject;
      this.body = body;
   }
}
